// -------------------- 系统配置（以秒为单位，自动转换为样本） --------------------
const SAMPLE_RATE = 4;                // 每秒采样次数（samples/sec）——只需修改这一个值

// const BASELINE_SEGMENT_SEC = 600;     // ★ 基线分段长度：600s(10min) 贴近 NICHD/FIGO
// const ACC_DURATION_TERM_SEC = 15;       // 满期加速最小持续时间 (秒)   [宽松模式 12]  加速次数
// const ACC_DURATION_PRETERM_SEC = 10;    // 早产加速最小持续时间 (秒)   [宽松模式 8]  加速次数
// const MIN_DECEL_DURATION_SEC = 15;      // 最小减速持续时间 (秒)      [宽松模式 20]  减速次数
// const PROLONGED_DECEL_LOW_SEC = 120;    // 延长减速下限（秒, 2分钟）   [宽松模式 180] 减速次数
// const PROLONGED_DECEL_HIGH_SEC = 600;   // 延长减速上限（秒, 10分钟)   
// const VARIABILITY_WINDOW_SEC = 60;      // 变异分析窗口 (秒)
// const EARLY_DECEL_WINDOW_SEC = 7;       // 早期减速与宫缩峰值的时差容许 ±7 秒   [宽松模式 10]  减速次数
// const LATE_DECEL_WINDOW_SEC = 30;       // 晚期减速：峰值之后30秒内       [宽松模式 35]    减速次数
// const FETAL_MOVEMENT_MAX_DURATION_SEC = 30; // 用于推断胎动的最大加速持续时间（秒）[宽松模式 35]   胎动
// const STV_WINDOW_SIZE = 16;             // 短变异计算窗口大小（样本数）
// const BASELINE_STABILITY_THRESHOLD = 10; // 基线稳定性阈值 (bpm)  [宽松模式 12]   

// // 以幅度定义的阈值（与秒无关）
// const ACC_THRESHOLD_TERM = 15;       // 满期加速阈值 (bpm)  [宽松模式 12] 加速次数
// const ACC_THRESHOLD_PRETERM = 10;    // 早产加速阈值 (bpm)   [宽松模式 8] 加速次数
// const DECEL_DEPTH_THRESHOLD = 15;    // 减速深度阈值 (bpm)  [宽松模式 20]  减速次数
// const SEVERE_DECEL_THRESHOLD = 30;   // 严重减速幅度阈值 (bpm)  [宽松模式 35]  减速次数
// const SEVERE_DECEL_ABSOLUTE_HR = 100; // 若最低心率 < 100bpm 也视为严重警示   [宽松模式 90]  减速次数
// const VARIABLE_DECEL_DEEP_THRESHOLD = 40; // 深度变异减速阈值 (bpm)     [宽松模式 45]  减速次数
// const VARIABLE_DECEL_RAPID_THRESHOLD = 30; // 快速下降阈值 (秒内下降)   [宽松模式 35]  减速次数



const BASELINE_SEGMENT_SEC = 600;     // ★ 基线分段长度：600s(10min) 贴近 NICHD/FIGO
const ACC_DURATION_TERM_SEC = 10;       // 满期加速最小持续时间 (秒)   [宽松模式 12]
const ACC_DURATION_PRETERM_SEC = 6;    // 早产加速最小持续时间 (秒)   [宽松模式 8]
const MIN_DECEL_DURATION_SEC = 20;      // 最小减速持续时间 (秒)      [宽松模式 20]
const PROLONGED_DECEL_LOW_SEC = 180;    // 延长减速下限（秒, 2分钟）   [宽松模式 180]
const PROLONGED_DECEL_HIGH_SEC = 600;   // 延长减速上限（秒, 10分钟)
const VARIABILITY_WINDOW_SEC = 60;      // 变异分析窗口 (秒)
const EARLY_DECEL_WINDOW_SEC = 10;       // 早期减速与宫缩峰值的时差容许 ±7 秒   [宽松模式 10]
const LATE_DECEL_WINDOW_SEC = 35;       // 晚期减速：峰值之后30秒内       [宽松模式 35]
const FETAL_MOVEMENT_MAX_DURATION_SEC = 35; // 用于推断胎动的最大加速持续时间（秒）[宽松模式 35]
const STV_WINDOW_SIZE = 16;             // 短变异计算窗口大小（样本数）
const BASELINE_STABILITY_THRESHOLD = 12; // 基线稳定性阈值 (bpm)  [宽松模式 12]

// 以幅度定义的阈值（与秒无关）
const ACC_THRESHOLD_TERM = 10;       // 满期加速阈值 (bpm)  [宽松模式 12]
const ACC_THRESHOLD_PRETERM = 6;    // 早产加速阈值 (bpm)   [宽松模式 8]
const DECEL_DEPTH_THRESHOLD = 20;    // 减速深度阈值 (bpm)  [宽松模式 20]
const SEVERE_DECEL_THRESHOLD = 35;   // 严重减速幅度阈值 (bpm)  [宽松模式 35]
const SEVERE_DECEL_ABSOLUTE_HR = 90; // 若最低心率 < 100bpm 也视为严重警示   [宽松模式 90]
const VARIABLE_DECEL_DEEP_THRESHOLD = 45; // 深度变异减速阈值 (bpm)     [宽松模式 45]
const VARIABLE_DECEL_RAPID_THRESHOLD = 35; // 快速下降阈值 (秒内下降)   [宽松模式 35]

// 根据 SAMPLE_RATE 自动转换为样本计数的常量
const BASELINE_SEGMENT = BASELINE_SEGMENT_SEC * SAMPLE_RATE;
const ACC_DURATION_TERM_SAMPLES = ACC_DURATION_TERM_SEC * SAMPLE_RATE;
const ACC_DURATION_PRETERM_SAMPLES = ACC_DURATION_PRETERM_SEC * SAMPLE_RATE;
const MIN_DECEL_DURATION_SAMPLES = MIN_DECEL_DURATION_SEC * SAMPLE_RATE;
const PROLONGED_DECEL_LOW_SAMPLES = PROLONGED_DECEL_LOW_SEC * SAMPLE_RATE;
const PROLONGED_DECEL_HIGH_SAMPLES = PROLONGED_DECEL_HIGH_SEC * SAMPLE_RATE;
const VARIABILITY_WINDOW_SAMPLES = VARIABILITY_WINDOW_SEC * SAMPLE_RATE;
const EARLY_DECEL_WINDOW_SAMPLES = EARLY_DECEL_WINDOW_SEC * SAMPLE_RATE;
const LATE_DECEL_WINDOW_SAMPLES = LATE_DECEL_WINDOW_SEC * SAMPLE_RATE;
const FETAL_MOVEMENT_MAX_DURATION_SAMPLES = FETAL_MOVEMENT_MAX_DURATION_SEC * SAMPLE_RATE;
const VARIABLE_DECEL_RAPID_SAMPLES = VARIABLE_DECEL_RAPID_THRESHOLD * SAMPLE_RATE;

const UC_PEAK_THRESHOLD_PERCENT = 0.3; // 宫缩峰值阈值百分比

// -------------------- 数据结构 --------------------
const DECEL_NONE = 0;
const DECEL_EARLY = 1;
const DECEL_LATE = 2;
const DECEL_VARIABLE = 3;
const DECEL_PROLONGED = 4;

const VARIABILITY_ABSENT = 0;     // <2 bpm
const VARIABILITY_MINIMAL = 1;    // 2-5 bpm
const VARIABILITY_MODERATE = 2;   // 6-25 bpm
const VARIABILITY_MARKED = 3;     // >25 bpm


const ARRHYTHMIA_NONE = 0;
const ARRHYTHMIA_BRADYCARDIA = 1;
const ARRHYTHMIA_TACHYCARDIA = 2;
const ARRHYTHMIA_LOW_VARIABILITY = 3;
const ARRHYTHMIA_ABNORMAL_ACCEL = 4;
const ARRHYTHMIA_ABNORMAL_DECEL = 5;
const ARRHYTHMIA_AV_BLOCK = 6;

class Deceleration {
    constructor() {
        this.start_index = 0;
        this.peak_index = 0;    // 最低点索引
        this.end_index = 0;
        this.depth = 0;         // 基线 - 最低点 (bpm)
        this.duration_seconds = 0;
        this.type = DECEL_NONE;
        this.severe = false;       // 是否严重（绝对HR或深度）
    }
}

class Contraction {
    constructor() {
        this.start_index = 0;
        this.peak_index = 0;
        this.end_index = 0;
        this.amplitude = 0;
        this.duration_seconds = 0;
    }
}

class FischerScore {
    constructor() {
        this.baseline = 0;
        this.variability_amp = 0;
        this.variability_freq = 0;
        this.accelerations = 0;
        this.decelerations = 0;
        this.total = 0;
    }
}

class KrebsScore {
    constructor() {
        this.baseline = 0;
        this.variability_amp = 0;
        this.variability_freq = 0;
        this.accelerations = 0;
        this.decelerations = 0;
        this.fetal_movement = 0;
        this.total = 0;
    }
}

class FetalMonitoringResult {
    constructor() {
        this.fhr_data = []
        this.isError = 0;                //是否有效 0有效 1无效
        this.baseline = 0;               // 基线心率(bpm)
        this.ltv_amplitude = 0;          // 长变异振幅(bpm)
        this.variability_cat = VARIABILITY_ABSENT; // 变异分级
        this.stv = 0;                    // 短变异 (ms)
        this.ltv_frequency = 0;          // 长变异频率(次/分钟)
        this.acceleration_count = 0;     // 加速次数
        this.deceleration_count = 0;     // 减速次数
        this.fetal_movement_count = 0;   // 胎动次数
        this.fetal_movement_times = [];  // 胎动发生时间点（样本索引）
        this.sinusoidal_pattern = false;    // 正弦波型标志
        this.baseline_stable = false;       // 基线是否稳定

        this.decelerations = Array(50).fill().map(() => new Deceleration());
        this.contractions = Array(50).fill().map(() => new Contraction());
        this.contraction_count = 0;

        this.fischer_score = new FischerScore();
        this.krebs_score = new KrebsScore();

        this.arrhythmia_detected = false;
        this.arrhythmia_type = ARRHYTHMIA_NONE;    //心律失常分级
        this.arrhythmia_details = "";

        this.interpretation = "";
    }
}

// -------------------- 工具函数 --------------------
function calculateMedian (data, start, end) {
    if (start > end) return 0;
    const n = end - start + 1;
    const buf = data.slice(start, end + 1);
    buf.sort((a, b) => a - b);
    return buf[Math.floor(n / 2)];
}

function morphologicalFilter (data, len, window_size) {
    if (window_size <= 1) return;
    const half = Math.floor(window_size / 2);
    const out = [...data];

    for (let i = half; i < len - half; i++) {
        const win = data.slice(i - half, i + half + 1);
        win.sort((a, b) => a - b);
        out[i] = win[Math.floor(window_size / 2)];
    }

    for (let i = 0; i < len; i++) {
        data[i] = out[i];
    }
}

//---------20250828  start-------

// 计算某段平均值
function calcAvg (fhr, start, end) {
    if (end <= start) return 0;
    let sum = 0;
    let n = 0;
    for (let i = start; i < end; i++) {
        sum += fhr[i];
        n++;
    }
    return n > 0 ? sum / n : 0;
}

// 判断方差（变异性）
function calcVariance (fhr, start, end, mean) {
    if (end <= start) return 0;
    let sum = 0;
    let n = 0;
    for (let i = start; i < end; i++) {
        let d = fhr[i] - mean;
        sum += d * d;
        n++;
    }
    return n > 0 ? sum / n : 0;
}
// ===================== 过滤异常 =====================



// 使用全局基线值替换异常点，避免基线穿越
function filterArtifactsWithJump (fhr, baseline, sampleRate = 4, result) {
    const HARD_LOW = 50;
    const HARD_HIGH = 210;
    const JUMP_THRESHOLD = 50;
    const MIN_ABNORMAL_SEC = 5;
    const MIN_ABNORMAL_LEN = MIN_ABNORMAL_SEC * sampleRate;
    const MAX_LOSS_RATE = 0.2;

    let lostCount = 0;

    let i = 1;
    while (i < fhr.length) {
        // ① 硬阈值过滤
        if (fhr[i] < HARD_LOW || fhr[i] > HARD_HIGH) {
            // 获取上一个正常值（如果存在）
            let prevNormalValue = i > 0 ? fhr[i - 1] : baseline;


            if (prevNormalValue < baseline) {
                // 上一个正常值在基线下方，替换值也在基线下方 [-6, 0]
                fhr[i] = baseline + (Math.floor(Math.random() * 7) - 6);
            } else if (prevNormalValue > baseline) {
                // 上一个正常值在基线上方，替换值也在基线上方 [0, 6]
                fhr[i] = baseline + (Math.floor(Math.random() * 7));
            } else {
                // 上一个正常值就是基线，使用原来的随机范围 [-3, 3]
                fhr[i] = baseline + (Math.floor(Math.random() * 7) - 3);

            }

            lostCount++;
            i++;
            continue;
        }

        // ② 突变检测
        // ② 突变检测
        if (Math.abs(fhr[i] - fhr[i - 1]) > JUMP_THRESHOLD) {
            let start = i;
            let j = i + 1;

            // 找到异常段的结束位置
            while (j < fhr.length && Math.abs(fhr[j] - baseline) > JUMP_THRESHOLD) {
                j++;
            }

            let abnormalLen = j - start;

            if (abnormalLen >= MIN_ABNORMAL_LEN) {
                // 获取异常段开始前的一个正常值
                let referenceValue = start > 0 ? fhr[start - 1] : baseline;

                // 获取异常段结束后的第一个正常值（如果存在）
                let nextNormalValue = j < fhr.length ? fhr[j] : baseline;

                // 确定整个异常段的趋势方向
                // 如果前后正常值都在基线同一侧，则保持在该侧
                // 如果跨越基线，则创建平滑过渡

                if ((referenceValue < baseline && nextNormalValue < baseline) ||
                    (referenceValue > baseline && nextNormalValue > baseline)) {
                    // 前后都在基线同一侧，保持在同一侧
                    const isBelowBaseline = referenceValue < baseline;

                    for (let k = start; k < j; k++) {
                        if (isBelowBaseline) {
                            fhr[k] = baseline + (Math.floor(Math.random() * 7) - 6);
                        } else {
                            fhr[k] = baseline + (Math.floor(Math.random() * 7));
                        }
                        lostCount++;
                    }
                } else {
                    // 前后跨越基线，创建平滑过渡
                    const totalChange = nextNormalValue - referenceValue;
                    const stepChange = totalChange / (abnormalLen + 1);

                    for (let k = start; k < j; k++) {
                        const progress = (k - start + 1) / (abnormalLen + 1);
                        const targetValue = Math.floor(referenceValue + totalChange * progress);
                        fhr[k] = targetValue + (Math.floor(Math.random() * 7) - 3);
                        lostCount++;
                    }
                }
            }
            i = j;
        } else {
            i++;
        }
    }

    // ③ 信号丢失率检测
    let lossRate = lostCount / fhr.length;
    //   console.log(`lost_count = ${lostCount}, len = ${fhr.length}, loss_rate = ${lossRate.toFixed(2)}`);
    if (lossRate > MAX_LOSS_RATE) {
        result.isError = 1
        // console.log("丢失率过高，数据无效");
    }
    return fhr; // 返回修正后的数组
}

//---------20250828  end-------

function calculateBaseline (fhr_data, data_len, baseline_out, stable) {
    let segment_size = BASELINE_SEGMENT;
    if (segment_size <= 0) segment_size = 1;
    const segments = Math.ceil(data_len / segment_size);

    if (segments < 2) {
        stable.value = true;
        const global_median = calculateMedian(fhr_data, 0, data_len - 1);
        baseline_out.fill(global_median);
        return;
    }

    const segment_medians = [];
    for (let i = 0; i < segments; i++) {
        const s = i * segment_size;
        const e = Math.min(s + segment_size - 1, data_len - 1);
        segment_medians.push(calculateMedian(fhr_data, s, e));
    }

    // 检查基线稳定性：相邻段差异不超过阈值
    stable.value = true;
    for (let i = 1; i < segments; i++) {
        if (Math.abs(segment_medians[i] - segment_medians[i - 1]) > BASELINE_STABILITY_THRESHOLD) {
            stable.value = false;
            break;
        }
    }

    const global_median = calculateMedian(segment_medians, 0, segments - 1);
    // 移除与全局偏差太大的段（阈值可调整，保持稳健）
    const valid_segments = segment_medians.filter(m => Math.abs(m - global_median) <= 25);
    const final_baseline = valid_segments.length > 0 ? calculateMedian(valid_segments, 0, valid_segments.length - 1) : global_median;

    baseline_out.fill(final_baseline);
}

function calculateStv (fhr_data, data_len) {
    if (data_len < 2) return 0;
    const window_size = STV_WINDOW_SIZE;
    const windows = data_len - window_size + 1;
    if (windows < 1) return 0;

    const stv_values = [];

    for (let w = 0; w < windows; w++) {
        let sum_sq_diff = 0.0;
        let count = 0;
        for (let i = w + 1; i < w + window_size; i++) {
            if (fhr_data[i] > 0 && fhr_data[i - 1] > 0) {
                // 转换为RR间期（毫秒）
                const rr_i = 60000.0 / fhr_data[i];
                const rr_i_prev = 60000.0 / fhr_data[i - 1];
                const diff = rr_i - rr_i_prev;
                sum_sq_diff += diff * diff;
                count++;
            }
        }
        if (count > 0) {
            const rmssd = Math.sqrt(sum_sq_diff / count);
            stv_values.push(rmssd);
        } else {
            stv_values.push(0.0);
        }
    }

    // 取中位数作为最终STV
    stv_values.sort((a, b) => a - b);
    return Math.round(stv_values[Math.floor(windows / 2)]);
}

function analyzeVariability (fhr_data, baseline, data_len, result) {
    const window_size = VARIABILITY_WINDOW_SAMPLES;
    const windows = Math.ceil(data_len / window_size);
    const ampls = [];

    for (let w = 0; w < windows; w++) {
        const s = w * window_size;
        const e = Math.min(s + window_size - 1, data_len - 1);
        let mn = Infinity, mx = -Infinity;
        for (let i = s; i <= e; i++) {
            if (fhr_data[i] < mn) mn = fhr_data[i];
            if (fhr_data[i] > mx) mx = fhr_data[i];
        }
        ampls.push((mn === Infinity || mx === -Infinity) ? 0 : (mx - mn));
    }

    ampls.sort((a, b) => a - b);
    const idx95 = Math.min(Math.ceil(0.95 * windows) - 1, windows - 1);
    result.ltv_amplitude = ampls[idx95];

    // 变异分级
    if (result.ltv_amplitude < 2) result.variability_cat = VARIABILITY_ABSENT;
    else if (result.ltv_amplitude < 6) result.variability_cat = VARIABILITY_MINIMAL;
    else if (result.ltv_amplitude <= 25) result.variability_cat = VARIABILITY_MODERATE;
    else result.variability_cat = VARIABILITY_MARKED;

    // 计算短变异
    result.stv = calculateStv(fhr_data, data_len);

    // 频率计算
    let crossings = 0;
    for (let i = 1; i < data_len; i++) {
        const prev_below = (fhr_data[i - 1] < baseline[i - 1]);
        const curr_above = (fhr_data[i] >= baseline[i]);
        const prev_above = (fhr_data[i - 1] > baseline[i - 1]);
        const curr_below = (fhr_data[i] <= baseline[i]);
        if ((prev_below && curr_above) || (prev_above && curr_below)) crossings++;
    }

    const total_seconds = data_len / SAMPLE_RATE;
    const per_min = total_seconds > 0.0 ? (crossings * 60.0 / total_seconds) : 0.0;
    result.ltv_frequency = Math.round(per_min);
}

function detectSinusoidalPattern (fhr_data, baseline, data_len) {
    if (data_len < 120 * SAMPLE_RATE) return false; // 至少需要2分钟数据

    const window_size = 3 * 60 * SAMPLE_RATE; // 3分钟窗口
    const windows = Math.floor(data_len / window_size);
    if (windows < 1) return false;

    let valid_windows = 0;
    for (let w = 0; w < windows; w++) {
        const start = w * window_size;
        const end = Math.min(start + window_size - 1, data_len - 1);

        // 检查振幅和周期一致性
        let min_val = Infinity, max_val = -Infinity;
        let zero_crossings = 0;
        let prev_above = false;

        for (let i = start; i <= end; i++) {
            const diff = fhr_data[i] - baseline[i];
            if (diff < min_val) min_val = diff;
            if (diff > max_val) max_val = diff;

            if (i > start) {
                const current_above = (diff >= 0);
                if (current_above !== prev_above) zero_crossings++;
                prev_above = current_above;
            }
        }

        const amplitude = max_val - min_val;
        const cycles = zero_crossings / 2.0;
        const freq = cycles * 60.0 / (window_size / SAMPLE_RATE); // 周期/分钟

        // FIGO标准: 振幅5-15bpm, 频率3-5周期/分钟, 固定正弦模式
        if (amplitude >= 5 && amplitude <= 15 &&
            freq >= 3.0 && freq <= 5.0 &&
            zero_crossings > 4) {
            valid_windows++;
        }
    }

    // 超过50%窗口符合条件则认为存在正弦波
    return valid_windows > windows / 2;
}

function detectAccelerations (fhr_data, baseline, data_len, result, gestational_age_weeks) {
    result.acceleration_count = 0;
    result.fetal_movement_count = 0;
    result.fetal_movement_times = [];
    let in_acc = false;
    let acc_start = 0;
    let peak_value = 0;
    let peak_index = 0;

    const acc_threshold = (gestational_age_weeks >= 32) ? ACC_THRESHOLD_TERM : ACC_THRESHOLD_PRETERM;
    const acc_min_duration_samples = (gestational_age_weeks >= 32) ? ACC_DURATION_TERM_SAMPLES : ACC_DURATION_PRETERM_SAMPLES;

    for (let i = 0; i < data_len; i++) {
        if (!in_acc) {
            if (fhr_data[i] >= baseline[i] + acc_threshold) {
                in_acc = true;
                acc_start = i;
                peak_value = fhr_data[i];
                peak_index = i;
            }
        } else {
            if (fhr_data[i] > peak_value) {
                peak_value = fhr_data[i];
                peak_index = i; // 更新峰值位置
            }
            const duration_samples = i - acc_start;
            // 结束条件：回落到低于阈值或太长
            if (fhr_data[i] < baseline[i] + acc_threshold - 5 || duration_samples > (300 * SAMPLE_RATE)) {
                if (duration_samples >= acc_min_duration_samples && peak_value >= baseline[i] + acc_threshold) {
                    result.acceleration_count++;
                    // 仅当持续时间较短（<=配置秒）时认为可能与胎动相关
                    if (duration_samples <= FETAL_MOVEMENT_MAX_DURATION_SAMPLES) {
                        result.fetal_movement_times.push(peak_index); // 记录胎动时间点
                        result.fetal_movement_count++;
                    }
                }
                in_acc = false;
            }
        }
    }

    if (in_acc) {
        const duration_samples = data_len - acc_start;
        if (duration_samples >= acc_min_duration_samples && peak_value >= baseline[data_len - 1] + acc_threshold) {
            result.acceleration_count++;
            if (duration_samples <= FETAL_MOVEMENT_MAX_DURATION_SAMPLES) {
                result.fetal_movement_times.push(peak_index);
                result.fetal_movement_count++;
            }
        }
    }
}

function detectDecelerations (fhr_data, baseline, uc_data, data_len, result) {
    result.deceleration_count = 0;
    let in_decel = false;
    let start_idx = 0, lowest_idx = 0;
    let max_depth = 0;

    for (let i = 0; i < data_len; i++) {
        const depth = baseline[i] - fhr_data[i]; // 正值表示低于基线
        if (!in_decel) {
            if (depth >= DECEL_DEPTH_THRESHOLD) {
                const need_samples = MIN_DECEL_DURATION_SAMPLES;
                let sustained = true;
                for (let j = 0; j < need_samples && (i + j) < data_len; j++) {
                    if (baseline[i + j] - fhr_data[i + j] < DECEL_DEPTH_THRESHOLD) {
                        sustained = false;
                        break;
                    }
                }
                if (sustained) {
                    in_decel = true;
                    start_idx = i;
                    lowest_idx = i;
                    max_depth = depth;
                    i += need_samples - 1; // 保守跳跃
                }
            }
        } else {
            if (depth > max_depth) {
                max_depth = depth;
                lowest_idx = i;
            }
            const duration_samples = i - start_idx;
            let recovered = false;
            const check_samples = 5 * SAMPLE_RATE;
            if (i + check_samples < data_len) {
                let cnt_ok = 0;
                for (let j = 0; j < check_samples; j++) {
                    if (fhr_data[i + j] >= baseline[i + j] - 5) cnt_ok++;
                }
                if (cnt_ok >= check_samples * 0.6) recovered = true;
            }

            if (recovered || duration_samples >= PROLONGED_DECEL_HIGH_SAMPLES) {
                const descend_time = lowest_idx - start_idx;
                const recover_time = i - lowest_idx;
                const ratio = (descend_time > 0 && recover_time > 0) ? descend_time / recover_time : 0.0;
                if (duration_samples >= MIN_DECEL_DURATION_SAMPLES && (ratio >= 0.01 && ratio <= 1000.0)) {
                    const d = result.decelerations[result.deceleration_count];
                    d.start_index = start_idx;
                    d.peak_index = lowest_idx;
                    d.end_index = i;
                    d.depth = max_depth;
                    d.duration_seconds = duration_samples / SAMPLE_RATE;
                    d.type = DECEL_NONE;
                    // 严重判定：幅度或绝对HR
                    const lowest_hr = baseline[lowest_idx] - max_depth;
                    d.severe = (max_depth >= SEVERE_DECEL_THRESHOLD) || (lowest_hr < SEVERE_DECEL_ABSOLUTE_HR);
                    result.deceleration_count++;
                }
                in_decel = false;
                i += 2 * SAMPLE_RATE;
            }
        }
    }
}

function detectContractions (uc_data, data_len, result) {
    result.contraction_count = 0;
    if (!uc_data) return;

    let in_c = false;
    let s = 0, peak = 0, peak_idx = 0;

    for (let i = 0; i < data_len; i++) {
        const val = uc_data[i];
        if (!in_c) {
            if (val > 20) {
                in_c = true;
                s = i;
                peak = val;
                peak_idx = i;
            }
        } else {
            if (val > peak) {
                peak = val;
                peak_idx = i;
            }
            if (val < 10 || (i - s) / SAMPLE_RATE > 300) {
                const dur = (i - s) / SAMPLE_RATE;
                if (dur >= 30) {
                    if (result.contraction_count < 50) {
                        const c = result.contractions[result.contraction_count];
                        c.start_index = s;
                        c.peak_index = peak_idx;
                        c.end_index = i;
                        c.amplitude = peak;
                        c.duration_seconds = dur;
                        result.contraction_count++;
                    }
                }
                in_c = false;
            }
        }
    }
}

function classifyDecelerations (result, baseline_array) {
    for (let i = 0; i < result.deceleration_count; i++) {
        const d = result.decelerations[i];
        if (d.type !== DECEL_NONE) continue;

        const sidx = d.start_index;
        const dur = d.duration_seconds;
        const depth = d.depth;
        let assigned = false;

        // 特征检测：深度>40bpm且快速下降（30秒内）
        const descend_time = (d.peak_index - d.start_index) / SAMPLE_RATE;
        if (depth >= VARIABLE_DECEL_DEEP_THRESHOLD &&
            descend_time <= VARIABLE_DECEL_RAPID_THRESHOLD) {
            d.type = DECEL_VARIABLE;
            assigned = true;
        }

        if (!assigned) {
            for (let j = 0; j < result.contraction_count; j++) {
                const peak = result.contractions[j].peak_index;
                const td = sidx - peak; // 负为开始在峰前
                if (Math.abs(td) <= EARLY_DECEL_WINDOW_SAMPLES) {
                    d.type = DECEL_EARLY;
                    assigned = true;
                    break;
                } else if (td > 0 && td <= LATE_DECEL_WINDOW_SAMPLES) {
                    d.type = DECEL_LATE;
                    assigned = true;
                    break;
                }
            }
        }

        if (!assigned) {
            if (dur >= PROLONGED_DECEL_LOW_SEC && dur < PROLONGED_DECEL_HIGH_SEC) {
                d.type = DECEL_PROLONGED;
            } else {
                d.type = DECEL_VARIABLE;
            }
        }

        // 若达到严重条件则标记为变异/严重（需要临床判定）
        const lowest_hr = baseline_array[d.peak_index] - d.depth;
        if (d.severe || lowest_hr < SEVERE_DECEL_ABSOLUTE_HR) {
            d.type = DECEL_VARIABLE; // 严重时以变异
        }
    }
}

function fischerScoring (result) {
    // 基线评分
    if (result.baseline < 110 || result.baseline > 160) {
        result.fischer_score.baseline = 0;
    } else if ((result.baseline >= 110 && result.baseline <= 119) ||
        (result.baseline >= 151 && result.baseline <= 160)) {
        result.fischer_score.baseline = 1;
    } else {
        result.fischer_score.baseline = 2;
    }

    // 变异振幅评分（使用分类）
    switch (result.variability_cat) {
        case VARIABILITY_ABSENT: result.fischer_score.variability_amp = 0; break;
        case VARIABILITY_MINIMAL: result.fischer_score.variability_amp = 1; break;
        case VARIABILITY_MODERATE: result.fischer_score.variability_amp = 2; break;
        case VARIABILITY_MARKED: result.fischer_score.variability_amp = 1; break;
    }

    // 变异频率评分
    if (result.ltv_frequency < 3) {
        result.fischer_score.variability_freq = 0;
    } else if (result.ltv_frequency > 6) {
        result.fischer_score.variability_freq = 2;
    } else {
        result.fischer_score.variability_freq = 1;
    }

    // 加速评分
    if (result.acceleration_count >= 2) {
        result.fischer_score.accelerations = 2;
    } else if (result.acceleration_count === 1) {
        result.fischer_score.accelerations = 1;
    } else {
        result.fischer_score.accelerations = 0;
    }

    // 减速评分
    let has_early = false, has_late = false, has_variable = false, has_prolonged = false;
    for (let i = 0; i < result.deceleration_count; i++) {
        switch (result.decelerations[i].type) {
            case DECEL_EARLY: has_early = true; break;
            case DECEL_LATE: has_late = true; break;
            case DECEL_VARIABLE: has_variable = true; break;
            case DECEL_PROLONGED: has_prolonged = true; break;
            default: break;
        }
    }

    if (has_late || has_variable || has_prolonged) {
        result.fischer_score.decelerations = 0;
    } else if (has_early) {
        result.fischer_score.decelerations = 1;
    } else {
        result.fischer_score.decelerations = 2;
    }

    result.fischer_score.total = result.fischer_score.baseline + result.fischer_score.variability_amp +
        result.fischer_score.variability_freq + result.fischer_score.accelerations +
        result.fischer_score.decelerations;

    // III类胎监：正弦波型或变异消失
    if (result.sinusoidal_pattern || result.variability_cat === VARIABILITY_ABSENT) {
        result.interpretation = "III类胎监：需紧急处理";
    }
    // 其他分类
    else if (result.fischer_score.total >= 8) {
        result.interpretation = "I类胎监：正常";
    } else if (result.fischer_score.total >= 5) {
        result.interpretation = "II类胎监：需进一步评估";
    } else {
        result.interpretation = "III类胎监：需紧急处理";
    }
}

function krebsScoring (result) {
    // 基线评分
    if (result.baseline < 110 || result.baseline > 160) {
        result.krebs_score.baseline = 0;
    } else if ((result.baseline >= 110 && result.baseline <= 119) ||
        (result.baseline >= 151 && result.baseline <= 160)) {
        result.krebs_score.baseline = 1;
    } else {
        result.krebs_score.baseline = 2;
    }

    // 变异振幅评分
    switch (result.variability_cat) {
        case VARIABILITY_ABSENT: result.krebs_score.variability_amp = 0; break;
        case VARIABILITY_MINIMAL: result.krebs_score.variability_amp = 1; break;
        case VARIABILITY_MODERATE: result.krebs_score.variability_amp = 2; break;
        case VARIABILITY_MARKED: result.krebs_score.variability_amp = 1; break;
    }

    // 变异频率评分
    if (result.ltv_frequency < 3) {
        result.krebs_score.variability_freq = 0;
    } else if (result.ltv_frequency > 6) {
        result.krebs_score.variability_freq = 2;
    } else {
        result.krebs_score.variability_freq = 1;
    }

    // 加速评分
    if (result.acceleration_count === 0) {
        result.krebs_score.accelerations = 0;
    } else if (result.acceleration_count <= 4) {
        result.krebs_score.accelerations = 1;
    } else {
        result.krebs_score.accelerations = 2;
    }

    // 减速评分
    if (result.deceleration_count === 0) {
        result.krebs_score.decelerations = 2;
    } else {
        let has_late = false, has_variable = false, has_prolonged = false;
        for (let i = 0; i < result.deceleration_count; i++) {
            if (result.decelerations[i].type === DECEL_LATE) has_late = true;
            if (result.decelerations[i].type === DECEL_VARIABLE) has_variable = true;
            if (result.decelerations[i].type === DECEL_PROLONGED) has_prolonged = true;
        }
        if (has_late || has_variable || has_prolonged) {
            result.krebs_score.decelerations = 0;
        } else {
            result.krebs_score.decelerations = 1;
        }
    }

    // 胎动评分
    if (result.fetal_movement_count === 0) {
        result.krebs_score.fetal_movement = 0;
    } else if (result.fetal_movement_count >= 5) {
        result.krebs_score.fetal_movement = 2;
    } else {
        result.krebs_score.fetal_movement = 1;
    }

    result.krebs_score.total = result.krebs_score.baseline + result.krebs_score.variability_amp +
        result.krebs_score.variability_freq + result.krebs_score.accelerations +
        result.krebs_score.decelerations + result.krebs_score.fetal_movement;
}
/* =====================  20250828 心律失常检测函数 ===================== */
function detectArrhythmia (fhrData, sampleRate, result) {
    const MIN_BASELINE_DURATION = 10 * 60 * sampleRate;
    const LOW_VARIABILITY_THRESHOLD = 5;
    const LOW_VARIABILITY_DURATION = 5 * 60 * sampleRate;

    result.arrhythmia_detected = false;
    result.arrhythmia_type = ARRHYTHMIA_NONE;
    result.arrhythmia_details = "无异常";

    if (fhrData.length < 2) {
        result.arrhythmia_details = "数据不足无法分析";
        return;
    }

    let brady = false, tachy = false, avBlock = false;
    let abnormalDecel = false, abnormalAccel = false, lowVar = false;
    let bradyDetail = "", tachyDetail = "", avBlockDetail = "";
    let decelDetail = "", accelDetail = "", lowvarDetail = "";

    // 1. 持续性心动过缓/过速
    let bradyStart = -1, tachyStart = -1;
    for (let i = 0; i < fhrData.length; i++) {
        // 心动过缓
        if (fhrData[i] < 110) {
            if (bradyStart === -1) bradyStart = i;
        } else {
            if (bradyStart !== -1 && i - bradyStart >= MIN_BASELINE_DURATION) {
                brady = true;
                bradyDetail = `持续性心动过缓（基线:${result.baseline} bpm, 持续:${Math.floor((i - bradyStart) / sampleRate)}秒）`;
            }
            bradyStart = -1;
        }

        // 心动过速
        if (fhrData[i] > 160) {
            if (tachyStart === -1) tachyStart = i;
        } else {
            if (tachyStart !== -1 && i - tachyStart >= MIN_BASELINE_DURATION) {
                tachy = true;
                tachyDetail = `持续性心动过速（基线:${result.baseline} bpm, 持续:${Math.floor((i - tachyStart) / sampleRate)}秒）`;
            }
            tachyStart = -1;
        }
    }

    // 2. 房室传导阻滞
    for (let i = 0; i + 180 * sampleRate < fhrData.length; i++) {
        let avg = calcAvg(fhrData, i, i + 180 * sampleRate);
        let variance = calcVariance(fhrData, i, i + 180 * sampleRate, avg);

        if (avg >= 50 && avg <= 80) {
            if (result.baseline > 0 && Math.abs(avg - result.baseline / 2.0) < 15) {
                if (variance < 25.0) {
                    avBlock = true;
                    avBlockDetail = "疑似房室传导阻滞（心率连续低于80 bpm）";
                }
            }
        }
    }

    // 3. 异常减速
    if (result.decelerations && result.decelerations.length > 0) {
        for (let d of result.decelerations) {
            if (d.type === DECEL_VARIABLE) { // 假设 type 用字符串表示
                abnormalDecel = true;
                decelDetail = `异常减速（深度:${d.depth} bpm）`;
                break;
            }
        }
    }

    // 4. 低变异性
    for (let i = 0; i <= fhrData.length - LOW_VARIABILITY_DURATION; i += sampleRate * 10) {
        let maxHr = -9999, minHr = 9999;
        for (let j = i; j < i + LOW_VARIABILITY_DURATION; j++) {
            if (fhrData[j] > maxHr) maxHr = fhrData[j];
            if (fhrData[j] < minHr) minHr = fhrData[j];
        }
        let amplitude = maxHr - minHr;
        if (amplitude <= LOW_VARIABILITY_THRESHOLD) {
            lowVar = true;
            lowvarDetail = `低变异性心率（1分钟振幅:${amplitude} bpm）`;
            break;
        }
    }

    // 5. 异常加速缺失
    if (result.acceleration_count === 0) {
        abnormalAccel = true;
        accelDetail = "异常加速缺失";
    }

    // 按优先级设置最终结果
    if (avBlock) {
        result.arrhythmia_type = ARRHYTHMIA_AV_BLOCK;
        result.arrhythmia_details = avBlockDetail;
    } else if (brady) {
        result.arrhythmia_type = ARRHYTHMIA_BRADYCARDIA;
        result.arrhythmia_details = bradyDetail;
    } else if (tachy) {
        result.arrhythmia_type = ARRHYTHMIA_TACHYCARDIA;
        result.arrhythmia_details = tachyDetail;
    } else if (abnormalDecel) {
        result.arrhythmia_type = ARRHYTHMIA_ABNORMAL_DECEL;
        result.arrhythmia_details = decelDetail;
    } else if (abnormalAccel) {
        result.arrhythmia_type = ARRHYTHMIA_ABNORMAL_ACCEL;
        result.arrhythmia_details = accelDetail;
    } else if (lowVar) {
        result.arrhythmia_type = ARRHYTHMIA_LOW_VARIABILITY;
        result.arrhythmia_details = lowvarDetail;
    } else {
        result.arrhythmia_type = ARRHYTHMIA_NONE;
        result.arrhythmia_details = "无异常";
    }
    //   console.log("心律失常类型:", result.arrhythmia_type);
    //   console.log("心律失常类型:", result.arrhythmia_type);
    //   console.log("心律失常详情:", result.arrhythmia_details);
    result.arrhythmia_detected = result.arrhythmia_type !== ARRHYTHMIA_NONE;
}

// 数据过滤
function filterFetalData (fhr_data) {
    const result = new FetalMonitoringResult();

    const data_len = fhr_data.length

    // 1. 预处理
    morphologicalFilter(fhr_data, data_len, 5);

    // 2. 基线
    const baseline = new Array(data_len).fill(0);
    const stable = { value: false };
    calculateBaseline(fhr_data, data_len, baseline, stable);
    result.baseline = baseline[0];
    result.baseline_stable = stable.value;

    // 过滤异常点
    filterArtifactsWithJump(fhr_data, result.baseline, 4, result);

    return fhr_data.join(',')
}

// 主分析函数
function fetalMonitoringScore (fhr_data, uc_data, data_len, gestational_age_weeks, is_not_filter) {
    const result = new FetalMonitoringResult();

    // 1. 预处理
    morphologicalFilter(fhr_data, data_len, 5);
    if (uc_data) morphologicalFilter(uc_data, data_len, 5);

    // 2. 基线
    const baseline = new Array(data_len).fill(0);
    const stable = { value: false };
    calculateBaseline(fhr_data, data_len, baseline, stable);
    result.baseline = baseline[0];
    result.baseline_stable = stable.value;

    // 过滤异常点
    if (is_not_filter) filterArtifactsWithJump(fhr_data, result.baseline, 4, result);

    // 3. 变异分析
    analyzeVariability(fhr_data, baseline, data_len, result);

    // 4. 特殊模式检测
    result.sinusoidal_pattern = detectSinusoidalPattern(fhr_data, baseline, data_len);

    // 5. 事件检测
    detectAccelerations(fhr_data, baseline, data_len, result, gestational_age_weeks);
    detectDecelerations(fhr_data, baseline, uc_data, data_len, result);

    if (uc_data) {
        detectContractions(uc_data, data_len, result);
    }

    classifyDecelerations(result, baseline);

    // 6. 评分
    fischerScoring(result);
    krebsScoring(result);

    // 7. 心律失常检测
    detectArrhythmia(fhr_data, 4, result);

    return result;
}

// 导出函数供外部使用
export default {
    fetalMonitoringScore,
    filterFetalData,
    FetalMonitoringResult,
    DECEL_NONE,
    DECEL_EARLY,
    DECEL_LATE,
    DECEL_VARIABLE,
    DECEL_PROLONGED,
    VARIABILITY_ABSENT,
    VARIABILITY_MINIMAL,
    VARIABILITY_MODERATE,
    VARIABILITY_MARKED
};
